const faqs = [
  {
    "category": "Getting started",
    "id": "what-is-entremap",
    "question": "What is EntreMap?",
    "answer": "EntreMap is a research-based self-assessment for exploring your entrepreneurial mindset. It helps you reflect on your responses, recognise patterns and consider areas for development. It is a starting point for learning and action, not a prediction of business success."
  },
  {
    "category": "Getting started",
    "id": "who-is-it-for",
    "question": "Do I need to be starting a business?",
    "answer": "No. EntreMap is for students, professionals, founders, business owners and people creating change within organisations or communities. Entrepreneurial thinking can support value creation in education, government, industry and everyday work."
  },
  {
    "category": "Getting started",
    "id": "how-long",
    "question": "How long does the assessment take?",
    "answer": "Allow approximately 15-20 minutes. Give yourself time to answer thoughtfully, using your own experience rather than what you think an entrepreneur should say."
  },
  {
    "category": "Getting started",
    "id": "save-progress",
    "question": "Can I return to an assessment later?",
    "answer": "Yes. Answers save automatically while you complete the assessment. Before leaving, select Save and exit and wait for it to return you to your Profile. Sign in with the same account and select Resume assessment to restore your saved answers and page. If saving fails, keep the assessment open, check your connection and select Retry saving. Changes that have not reached the server cannot be restored after closing the page."
  },
  {
    "category": "Getting started",
    "id": "repeat-assessment",
    "question": "Can I take the assessment again?",
    "answer": "Yes. Repeat assessments can support reflection over time. Check your Profile for earlier completed assessments first, and use the same account so your records remain together."
  },
  {
    "category": "Signing in",
    "id": "same-account",
    "question": "Which sign-in method should I use?",
    "answer": "Use the same email address and sign-in method you used when completing your assessment. Google, QUT/Microsoft and email-and-password sign-in are different routes. Accounts with different email addresses may have separate assessment records."
  },
  {
    "category": "Signing in",
    "id": "qut-login",
    "question": "How do I sign in with my QUT account?",
    "answer": "Choose Sign in with QUT and complete the Microsoft sign-in process for your QUT account. An EntreMap email-and-password account is separate from QUT/Microsoft sign-in. If access fails, note the error message and contact us with the account email you used."
  },
  {
    "category": "Signing in",
    "id": "gmail-qut",
    "question": "I started with QUT but completed the assessment through Gmail. Where are my results?",
    "answer": "Try Google sign-in with the Gmail account you used to complete the assessment, then open Profile. Signing in with your QUT email may open a different account. Contact us if you cannot locate the completed assessment; do not create another account just to retrieve it."
  },
  {
    "category": "Signing in",
    "id": "password-help",
    "question": "What if I cannot remember my EntreMap password?",
    "answer": "Check whether you originally used Google or QUT/Microsoft sign-in, which do not use a separate EntreMap password. If you registered with an EntreMap password and cannot sign in, contact us for account assistance. Never send your password or verification codes."
  },
  {
    "category": "Signing in",
    "id": "linkedin-disabled",
    "question": "Why does LinkedIn say “The application is disabled”?",
    "answer": "That message indicates the LinkedIn application is unavailable. If your existing EntreMap account already has another sign-in method, use it. Otherwise contact us for help recovering access before creating a replacement account or repeating your assessment."
  },
  {
    "category": "Results and reports",
    "id": "find-results",
    "question": "Where can I find my completed results?",
    "answer": "Sign in to the account used for the assessment and open Profile. Select the completed assessment you want to view. If it is missing, check the email address and sign-in method before contacting us."
  },
  {
    "category": "Results and reports",
    "id": "reference-average",
    "question": "What does the reference average mean?",
    "answer": "When available, the Overall EntreMap reference average summarises valid scores from submitted assessments. It is a reference point only, not a population norm or a validated benchmark. It is not filtered by cohort, role or date, and may change as new assessments are submitted. Repeat submissions can contribute more than once."
  },
  {
    "category": "Results and reports",
    "id": "no-average",
    "question": "Why might my report have no comparison average?",
    "answer": "Comparison data may be unavailable or there may be too few valid responses for a measure. The application requires at least five valid scores for a comparison measure. An unavailable comparison does not mean your personal assessment has been lost."
  },
  {
    "category": "Results and reports",
    "id": "interpret-results",
    "question": "How should I use my results?",
    "answer": "Use them to ask questions about your current habits, experiences and context. Look for patterns you recognise and choose a practical next step. Higher scores are not automatically better on every measure, and raw totals from different scales should not be directly ranked against one another."
  },
  {
    "category": "Results and reports",
    "id": "pdf-help",
    "question": "What if a PDF export fails or the page breaks look wrong?",
    "answer": "Wait for the full report to load, then try the export again. If the file is incomplete or cuts across charts, send us the report type and a screenshot of the layout problem. Avoid including other participants’ information in your screenshot."
  },
  {
    "category": "Troubleshooting",
    "id": "403",
    "question": "I completed the assessment but received a 403 error. Is my data lost?",
    "answer": "A 403 means a request was refused. It does not by itself show whether an assessment saved. If you reached the report before the error, your submission may already be stored. Sign in using the same account and check Profile before repeating the assessment. Contact us if the results are absent or the error returns."
  },
  {
    "category": "Troubleshooting",
    "id": "401",
    "question": "What does a 401 error or an unexpected sign-out mean?",
    "answer": "The application could not verify your current session. Sign in again with the original account, then check Profile for saved work. If this happens during an assessment, keep the page open and note the error and approximate time before taking further action."
  },
  {
    "category": "Troubleshooting",
    "id": "loading-error",
    "question": "What should I do if a page is blank, keeps loading or displays a server error?",
    "answer": "If you are viewing a report or another saved page, try reloading it once. Avoid repeatedly refreshing an assessment with unsaved answers. Check your connection and contact us if the issue continues, including the page, error text, approximate time, browser and device."
  },
  {
    "category": "Troubleshooting",
    "id": "support-details",
    "question": "What should I include when asking for technical help?",
    "answer": "Include your account email, sign-in method, the page or assessment involved, approximate time and what happened. Error text and a screenshot can help. Do not send passwords, verification codes, browser cookies or other participants’ records."
  },
  {
    "category": "Privacy and data",
    "id": "privacy",
    "question": "Where can I read about privacy and data use?",
    "answer": "Read the Privacy Policy and the privacy acknowledgement shown before starting an assessment. Contact EntreMap if you need clarification about your information, access or deletion requests."
  },
  {
    "category": "Privacy and data",
    "id": "delete-data",
    "question": "How can I request access to or deletion of my information?",
    "answer": "Use the Contact page and select Privacy or data request. Identify the email address associated with your EntreMap account and describe your request. Do not include passwords or verification codes. This sends a request for assistance; it does not automatically delete an account."
  }
];
export default faqs;


